import { zodResolver } from "@hookform/resolvers/zod"
import { X } from "lucide-react"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form"
import { Textarea } from "@/components/ui/textarea"

interface OwnerAdminMemoEditModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: FormValues) => Promise<void>
  body?: string
  isLoading: boolean
}

const formSchema = z.object({
  adminMemo: z.string().optional(),
})

type FormValues = z.infer<typeof formSchema>

export function OwnerAdminMemoEditModal({
  open,
  onOpenChange,
  onSubmit,
  body,
  isLoading,
}: OwnerAdminMemoEditModalProps) {
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      adminMemo: body || "",
    },
  })

  const handleSubmit = async (data: FormValues) => {
    try {
      await onSubmit(data)
      onOpenChange(false)
    } catch (e) {
      console.error(e)
    }
  }

  const handleCancel = () => {
    form.reset()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[620px] max-h-[90vh] overflow-y-auto p-0">
        <div className="p-4">
          <DialogHeader>
            <DialogTitle className="text-[18px] font-semibold">オーナー注意事項を編集</DialogTitle>
          </DialogHeader>

          <button
            type="button"
            onClick={handleCancel}
            className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">閉じる</span>
          </button>

          <Form {...form}>
            <form onSubmit={form.handleSubmit(handleSubmit)} className="mt-6 space-y-4">
              <FormField
                control={form.control}
                name="adminMemo"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Textarea
                        placeholder="オーナーに関する注意事項を入力してください"
                        className="min-h-[200px] resize-none"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* ボタン */}
              <div className="flex justify-end gap-3">
                <Button loading={isLoading} type="submit">
                  保存する
                </Button>
                <Button type="button" variant="outline" onClick={handleCancel}>
                  キャンセル
                </Button>
              </div>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  )
}
